import StartupLoader from './StartupLoader';

export default StartupLoader;
